import {
  Configuration,
  ConnectionsApi,
  EmailApi,
  IncentivePlanApi,
  MerchantApi,
  MerchantListApi,
  OrganizationApi,
  PaymentMethodsApi,
  PermissionTicketApi,
  PortalAdminApi,
  WorkspaceApi,
  WorkspaceMembersApi,
} from 'lib/generated/api'

export interface IApiClient {
  connectionsApi: ConnectionsApi
  emailApi: EmailApi
  incentivePlanApi: IncentivePlanApi
  merchantApi: MerchantApi
  merchantListApi: MerchantListApi
  organizationApi: OrganizationApi
  paymentMethodsApi: PaymentMethodsApi
  permissionTicketApi: PermissionTicketApi
  portalAdminApi: PortalAdminApi
  workspaceApi: WorkspaceApi
  workspaceMembersApi: WorkspaceMembersApi
}

export class ApiClient implements IApiClient {
  constructor(private configuration: Configuration) {}

  connectionsApi = new ConnectionsApi(this.configuration)
  emailApi = new EmailApi(this.configuration)
  incentivePlanApi = new IncentivePlanApi(this.configuration)
  merchantApi = new MerchantApi(this.configuration)
  merchantListApi = new MerchantListApi(this.configuration)
  organizationApi = new OrganizationApi(this.configuration)
  paymentMethodsApi = new PaymentMethodsApi(this.configuration)
  permissionTicketApi = new PermissionTicketApi(this.configuration)
  portalAdminApi = new PortalAdminApi(this.configuration)
  workspaceApi = new WorkspaceApi(this.configuration)
  workspaceMembersApi = new WorkspaceMembersApi(this.configuration)
}
